<template>
    <div class="billing_lists">
    <!-- 停車帳務_lists -->
    <loading v-if="loading"/>
    <section class="chapternav-top">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 text-center">
            <h2 class="section-heading text-uppercase">Billing</h2>
            <h3 class="section-subheading text-muted">停車帳務</h3>
          </div>
        </div>

        <div class="row">

          <!--資料為空時，顯示以下-->
          <div class="blank-box" v-if="billing_lists.length == 0 && !loading">
            <i class="fas fa-7x fa-grin-beam-sweat"></i><br>
            您目前尚無任何停車紀錄
          </div>
          <!--資料為空時，顯示以上-->

          <div class="col-lg-12 billing-lists-box row" v-if="billing_lists.length"> 
            <router-link class="col-lg-6" v-for="billing in billing_lists" :key="billing.id" :to="billing.paid_at ? 'billing_view?id=' + billing.id : 'billing_current_view?id=' + billing.id">
                  <div :class="{'billing-current-card': !billing.paid_at, 'billing-card': billing.paid_at, 'billing-lists-item': true}">
                      <div class="billing-current-title" v-if="!billing.paid_at">停車中</div>
                      <div class="billing-current-title" v-if="billing.reservation">預約停車</div>
                      <div class="billing-hint" v-if="!billing.paid_at"><i class="fas fa-arrow-right"></i></div>
                      <div class="billing-top-box">
                          <div class="billing-time-box">
                              <div class="billing-time" v-if="!billing.reservation">
                                {{ billing.counted_at | DateToDay }} <br/>
                                <span>{{ billing.counted_at | DateToTime }}</span>
                              </div>
                               <div class="billing-time" v-if="billing.reservation">
                                {{ billing.reservation.reservation_date }} <br/>
                                <span>00:00</span>
                              </div>
                              <div class="billing-arrow">
                                >
                              </div>
                              <div class="billing-time" v-if="billing.paid_at && !billing.reservation">
                                {{ billing.paid_at | DateToDay }}  <br/>
                                <span> {{ billing.paid_at | DateToTime }}</span>
                              </div>
                              <div class="billing-time" v-if="!billing.paid_at && !billing.reservation">
                                {{ currentTime | DateToDay }}  <br/>
                                <span> {{ currentTime | DateToTime }}</span>
                              </div>
                              <div class="billing-time" v-if="billing.reservation">
                                {{ billing.reservation.reservation_date }} <br/>
                                <span>23:59</span>
                              </div>
                              <div class="cb"></div>
                          </div>
                          <div class="billing-price-box" v-if="!billing.paid_at">
                              <div class="billing-current-price-title">已累計金額</div>
                              <div class="billing-current-price-number" v-if="billing.price">{{ billing.price.result }}</div>
                              <div class="cb"></div>
                          </div>
                          <div class="billing-price-box" v-if="billing.payment_records[0] && billing.paid_at">
                              <div class="billing-price-title">實付金額</div>
                              <div class="billing-price-number">{{ billing.payment_records[0].actual_fee }}</div>
                              <div class="cb"></div>
                              <div class="billing-price-title">應付金額</div>
                              <div class="billing-price-number2">{{ billing.payment_records[0].origin_fee }}</div>
                              <div class="cb"></div>
                          </div>
                          <div class="cb"></div>
                      </div><!--billing-top-box ends-->
                      <div class="billing-place-box">
                        <div class="billing-plate">{{ billing.plate }}</div>
                        <div class="billing-place">{{ billing.lot.name }}</div>
                        <div class="cb"></div>
                      </div>
                  </div><!--billing-card ends-->
            </router-link>
          </div><!--billing-lists-box ends-->
        </div>
      </div>
    </section>
    </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'BillingLists',
  props: {
  },
  filters: {
    DateToDay(value) {
      return moment(String(value)).format('YYYY.MM.DD')
    },
    DateToTime(value) {
      return moment(String(value)).format('HH:mm')
    }
  },
  data() {
    return {
      billing_lists: [],
      loading: true,
      currentTime: ""
    }
  },
  mounted() {
    var self = this
    self.getbillingLists()
    self.currentTime = moment().format("YYYY-MM-DD HH:mm")
  },
  methods: {
    getbillingLists: function() {
      var self = this
      self.$http.get('https://' + process.env.VUE_APP_API_URL + '/parking_records?access_token=' + self.$cookie.get('access_token'))
        .then((response) => {
          self.billing_lists = response.body
          self.loading = false
        })
        .catch((response) => {
          console.log("取得資料失敗")
          self.$router.push({ name: 'member_center' })
        })
        .finally(() => {
        });
    }
  }
}
</script>